var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A51457",
    d: "M115.746 0h792.508C972.178 0 1024 51.821 1024 115.746v792.508C1024 972.178 972.179 1024 908.254 1024H115.746C51.822 1024 0 972.179 0 908.254V115.746C0 51.822 51.821 0 115.746 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M649.925 767.223L298.562 256.776h76.145L726.07 767.223h-76.145zm107.641-21.644L394.75 218.534H225.814l403.971 586.931h168.936l-41.202-59.838z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M475.602 513.99l21.742 31.545-223.388 259.882h-48.725L475.602 513.99zM778.434 218.534l-238.82 277.79-21.693-31.545 211.74-246.245h48.773z"
  })));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/twitter-pink-d194279ce422054923a5ce35f496b3f4.svg";
export { SvgTwitterPink as ReactComponent };